import Vue from "vue";
import VueRouter from "vue-router";

import Business from "@/views/Business";
import Disclaimer from "@/views/Disclaimer";
import DisclosurePolicy from "@/views/DisclosurePolicy";
import Faq from "@/views/Faq";
import Governance from "@/views/Governance";
import Highlight from "@/views/Highlight";
import Home from "@/views/Home";
import Library from "@/views/Library";
import Material from "@/views/Material";
import Meeting from "@/views/Meeting";
import Message from "@/views/Message";
import News from "@/views/News";
import Notice from "@/views/Notice";
import Presentation from "@/views/Presentation";
import Schedule from "@/views/Schedule";
import Securities from "@/views/Securities";
import Stock from "@/views/Stock";
import StockQuotations from "@/views/StockQuotations";

Vue.use(VueRouter);

// 非同期読み込みにすると、document.writeで呼ばれているJavascriptが動作しなくなる
const routes = [
  {
    path: "/business",
    name: "事業内容",
    component: Business,
    meta: {
      breadcrumbs: [
        {
          path: "/governance",
          name: "経営方針",
        },
        {
          path: "/business",
          name: "事業内容",
        },
      ],
    },
  },
  {
    path: "/disclaimer",
    name: "免責事項",
    component: Disclaimer,
    meta: {
      breadcrumbs: [
        {
          path: "/disclaimer",
          name: "免責事項",
        },
      ],
    },
  },
  {
    path: "/disclosure_policy",
    name: "ディスクロージャーポリシー",
    component: DisclosurePolicy,
    meta: {
      breadcrumbs: [
        {
          path: "/governance",
          name: "経営方針",
        },
        {
          path: "/disclosure_policy",
          name: "ディスクロージャーポリシー",
        },
      ],
    },
  },
  {
    path: "/faq",
    name: "よくあるご質問",
    component: Faq,
    meta: {
      breadcrumbs: [
        {
          path: "/faq",
          name: "よくあるご質問",
        },
      ],
    },
  },
  {
    path: "/governance",
    name: "コーポレート・ガバナンス",
    component: Governance,
    meta: {
      breadcrumbs: [
        {
          path: "/governance",
          name: "経営方針",
        },
        {
          path: "/governance",
          name: "コーポレート・ガバナンス",
        },
      ],
    },
  },
  {
    path: "/highlight",
    name: "業績ハイライト",
    component: Highlight,
    meta: {
      breadcrumbs: [
        {
          path: "/highlight",
          name: "業績ハイライト",
        },
      ],
    },
  },
  {
    path: "/index",
    name: "IR情報トップ",
    component: Home,
    meta: {
      breadcrumbs: [
        {
          path: "/index",
          name: "IR情報トップ",
        },
      ],
    },
  },
  {
    path: "/library",
    name: "決算短信",
    component: Library,
    meta: {
      breadcrumbs: [
        {
          path: "/library",
          name: "IRライブラリー",
        },
        {
          path: "/library",
          name: "決算短信",
        },
      ],
    },
  },
  {
    path: "/material",
    name: "IR資料",
    component: Material,
    meta: {
      breadcrumbs: [
        {
          path: "/library",
          name: "IRライブラリー",
        },
        {
          path: "/material",
          name: "IR資料",
        },
      ],
    },
  },
  {
    path: "/meeting",
    name: "株主総会",
    component: Meeting,
    meta: {
      breadcrumbs: [
        {
          path: "/stock",
          name: "株式について",
        },
        {
          path: "/meeting",
          name: "株主総会",
        },
      ],
    },
  },
  {
    path: "/message",
    name: "株主・投資家の皆さまへ",
    component: Message,
    meta: {
      breadcrumbs: [
        {
          path: "/message",
          name: "株主・投資家の皆さまへ",
        },
      ],
    },
  },
  {
    path: "/news",
    name: "IRニュース",
    component: News,
    meta: {
      breadcrumbs: [
        {
          path: "/news",
          name: "IRニュース",
        },
      ],
    },
  },
  {
    path: "/notice",
    name: "電子公告",
    component: Notice,
    meta: {
      breadcrumbs: [
        {
          path: "/notice",
          name: "電子公告",
        },
      ],
    },
  },
  {
    path: "/presentation",
    name: "決算説明会資料",
    component: Presentation,
    meta: {
      breadcrumbs: [
        {
          path: "/library",
          name: "IRライブラリー",
        },
        {
          path: "/presentation",
          name: "決算説明会資料",
        },
      ],
    },
  },
  {
    path: "/schedule",
    name: "IRカレンダー",
    component: Schedule,
    meta: {
      breadcrumbs: [
        {
          path: "/schedule",
          name: "IRカレンダー",
        },
      ],
    },
  },
  {
    path: "/securities",
    name: "有価証券報告書",
    component: Securities,
    meta: {
      breadcrumbs: [
        {
          path: "/library",
          name: "IRライブラリー",
        },
        {
          path: "/securities",
          name: "有価証券報告書",
        },
      ],
    },
  },
  {
    path: "/stock",
    name: "株式情報",
    component: Stock,
    meta: {
      breadcrumbs: [
        {
          path: "/stock",
          name: "株式について",
        },
        {
          path: "/stock",
          name: "株式情報",
        },
      ],
    },
  },
  {
    path: "/stock_quotations",
    name: "株価情報",
    component: StockQuotations,
    meta: {
      breadcrumbs: [
        {
          path: "/stock",
          name: "株式について",
        },
        {
          path: "/stock_quotations",
          name: "株価情報",
        },
      ],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { selector: "#js-hero" };
    }
  },
});

export default router;
